function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import Delta from 'quill-delta';
import { EmbedBlot, Scope } from 'parchment';
import Quill from '../core/quill.js';
import logger from '../core/logger.js';
import Module from '../core/module.js';
var debug = logger('quill:toolbar');

var Toolbar =
/*#__PURE__*/
function (_Module) {
  _inherits(Toolbar, _Module);

  function Toolbar(quill, options) {
    var _this;

    _classCallCheck(this, Toolbar);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Toolbar).call(this, quill, options));

    if (Array.isArray(_this.options.container)) {
      var _quill$container, _quill$container$pare;

      var container = document.createElement('div');
      container.setAttribute('role', 'toolbar');
      addControls(container, _this.options.container);
      (_quill$container = quill.container) === null || _quill$container === void 0 ? void 0 : (_quill$container$pare = _quill$container.parentNode) === null || _quill$container$pare === void 0 ? void 0 : _quill$container$pare.insertBefore(container, quill.container);
      _this.container = container;
    } else if (typeof _this.options.container === 'string') {
      _this.container = document.querySelector(_this.options.container);
    } else {
      _this.container = _this.options.container;
    }

    if (!(_this.container instanceof HTMLElement)) {
      debug.error('Container required for toolbar', _this.options);
      return _possibleConstructorReturn(_this);
    }

    _this.container.classList.add('ql-toolbar');

    _this.controls = [];
    _this.handlers = {};

    if (_this.options.handlers) {
      Object.keys(_this.options.handlers).forEach(function (format) {
        var _this$options$handler;

        var handler = (_this$options$handler = _this.options.handlers) === null || _this$options$handler === void 0 ? void 0 : _this$options$handler[format];

        if (handler) {
          _this.addHandler(format, handler);
        }
      });
    }

    Array.from(_this.container.querySelectorAll('button, select')).forEach(function (input) {
      // @ts-expect-error
      _this.attach(input);
    });

    _this.quill.on(Quill.events.EDITOR_CHANGE, function () {
      var _this$quill$selection = _this.quill.selection.getRange(),
          _this$quill$selection2 = _slicedToArray(_this$quill$selection, 1),
          range = _this$quill$selection2[0]; // quill.getSelection triggers update


      _this.update(range);
    });

    return _this;
  }

  _createClass(Toolbar, [{
    key: "addHandler",
    value: function addHandler(format, handler) {
      this.handlers[format] = handler;
    }
  }, {
    key: "attach",
    value: function attach(input) {
      var _this2 = this;

      var format = Array.from(input.classList).find(function (className) {
        return className.indexOf('ql-') === 0;
      });
      if (!format) return;
      format = format.slice('ql-'.length);

      if (input.tagName === 'BUTTON') {
        input.setAttribute('type', 'button');
      }

      if (this.handlers[format] == null && this.quill.scroll.query(format) == null) {
        debug.warn('ignoring attaching to nonexistent format', format, input);
        return;
      }

      var eventName = input.tagName === 'SELECT' ? 'change' : 'click';
      input.addEventListener(eventName, function (e) {
        var value;

        if (input.tagName === 'SELECT') {
          // @ts-expect-error
          if (input.selectedIndex < 0) return; // @ts-expect-error

          var selected = input.options[input.selectedIndex];

          if (selected.hasAttribute('selected')) {
            value = false;
          } else {
            value = selected.value || false;
          }
        } else {
          if (input.classList.contains('ql-active')) {
            value = false;
          } else {
            // @ts-expect-error
            value = input.value || !input.hasAttribute('value');
          }

          e.preventDefault();
        }

        _this2.quill.focus();

        var _this2$quill$selectio = _this2.quill.selection.getRange(),
            _this2$quill$selectio2 = _slicedToArray(_this2$quill$selectio, 1),
            range = _this2$quill$selectio2[0];

        if (_this2.handlers[format] != null) {
          _this2.handlers[format].call(_this2, value);
        } else if ( // @ts-expect-error
        _this2.quill.scroll.query(format).prototype instanceof EmbedBlot) {
          value = prompt("Enter ".concat(format)); // eslint-disable-line no-alert

          if (!value) return;

          _this2.quill.updateContents(new Delta() // @ts-expect-error Fix me later
          .retain(range.index) // @ts-expect-error Fix me later
          ["delete"](range.length).insert(_defineProperty({}, format, value)), Quill.sources.USER);
        } else {
          _this2.quill.format(format, value, Quill.sources.USER);
        }

        _this2.update(range);
      });
      this.controls.push([format, input]);
    }
  }, {
    key: "update",
    value: function update(range) {
      var formats = range == null ? {} : this.quill.getFormat(range);
      this.controls.forEach(function (pair) {
        var _pair = _slicedToArray(pair, 2),
            format = _pair[0],
            input = _pair[1];

        if (input.tagName === 'SELECT') {
          var option = null;

          if (range == null) {
            option = null;
          } else if (formats[format] == null) {
            option = input.querySelector('option[selected]');
          } else if (!Array.isArray(formats[format])) {
            var value = formats[format];

            if (typeof value === 'string') {
              value = value.replace(/"/g, '\\"');
            }

            option = input.querySelector("option[value=\"".concat(value, "\"]"));
          }

          if (option == null) {
            // @ts-expect-error TODO fix me later
            input.value = ''; // TODO make configurable?
            // @ts-expect-error TODO fix me later

            input.selectedIndex = -1;
          } else {
            option.selected = true;
          }
        } else if (range == null) {
          input.classList.remove('ql-active');
          input.setAttribute('aria-pressed', 'false');
        } else if (input.hasAttribute('value')) {
          // both being null should match (default values)
          // '1' should match with 1 (headers)
          var _value = formats[format];
          var isActive = _value === input.getAttribute('value') || _value != null && _value.toString() === input.getAttribute('value') || _value == null && !input.getAttribute('value');
          input.classList.toggle('ql-active', isActive);
          input.setAttribute('aria-pressed', isActive.toString());
        } else {
          var _isActive = formats[format] != null;

          input.classList.toggle('ql-active', _isActive);
          input.setAttribute('aria-pressed', _isActive.toString());
        }
      });
    }
  }]);

  return Toolbar;
}(Module);

Toolbar.DEFAULTS = {};

function addButton(container, format, value) {
  var input = document.createElement('button');
  input.setAttribute('type', 'button');
  input.classList.add("ql-".concat(format));
  input.setAttribute('aria-pressed', 'false');

  if (value != null) {
    input.value = value;
    input.setAttribute('aria-label', "".concat(format, ": ").concat(value));
  } else {
    input.setAttribute('aria-label', format);
  }

  container.appendChild(input);
}

function addControls(container, groups) {
  if (!Array.isArray(groups[0])) {
    // @ts-expect-error
    groups = [groups];
  }

  groups.forEach(function (controls) {
    var group = document.createElement('span');
    group.classList.add('ql-formats');
    controls.forEach(function (control) {
      if (typeof control === 'string') {
        addButton(group, control);
      } else {
        var format = Object.keys(control)[0];
        var value = control[format];

        if (Array.isArray(value)) {
          addSelect(group, format, value);
        } else {
          addButton(group, format, value);
        }
      }
    });
    container.appendChild(group);
  });
}

function addSelect(container, format, values) {
  var input = document.createElement('select');
  input.classList.add("ql-".concat(format));
  values.forEach(function (value) {
    var option = document.createElement('option');

    if (value !== false) {
      option.setAttribute('value', String(value));
    } else {
      option.setAttribute('selected', 'selected');
    }

    input.appendChild(option);
  });
  container.appendChild(input);
}

Toolbar.DEFAULTS = {
  container: null,
  handlers: {
    clean: function clean() {
      var _this3 = this;

      var range = this.quill.getSelection();
      if (range == null) return;

      if (range.length === 0) {
        var formats = this.quill.getFormat();
        Object.keys(formats).forEach(function (name) {
          // Clean functionality in existing apps only clean inline formats
          if (_this3.quill.scroll.query(name, Scope.INLINE) != null) {
            _this3.quill.format(name, false, Quill.sources.USER);
          }
        });
      } else {
        this.quill.removeFormat(range.index, range.length, Quill.sources.USER);
      }
    },
    direction: function direction(value) {
      var _this$quill$getFormat = this.quill.getFormat(),
          align = _this$quill$getFormat.align;

      if (value === 'rtl' && align == null) {
        this.quill.format('align', 'right', Quill.sources.USER);
      } else if (!value && align === 'right') {
        this.quill.format('align', false, Quill.sources.USER);
      }

      this.quill.format('direction', value, Quill.sources.USER);
    },
    indent: function indent(value) {
      var range = this.quill.getSelection(); // @ts-expect-error

      var formats = this.quill.getFormat(range); // @ts-expect-error

      var indent = parseInt(formats.indent || 0, 10);

      if (value === '+1' || value === '-1') {
        var modifier = value === '+1' ? 1 : -1;
        if (formats.direction === 'rtl') modifier *= -1;
        this.quill.format('indent', indent + modifier, Quill.sources.USER);
      }
    },
    link: function link(value) {
      if (value === true) {
        value = prompt('Enter link URL:'); // eslint-disable-line no-alert
      }

      this.quill.format('link', value, Quill.sources.USER);
    },
    list: function list(value) {
      var range = this.quill.getSelection(); // @ts-expect-error

      var formats = this.quill.getFormat(range);

      if (value === 'check') {
        if (formats.list === 'checked' || formats.list === 'unchecked') {
          this.quill.format('list', false, Quill.sources.USER);
        } else {
          this.quill.format('list', 'unchecked', Quill.sources.USER);
        }
      } else {
        this.quill.format('list', value, Quill.sources.USER);
      }
    }
  }
};
export { Toolbar as default, addControls };